import(/* webpackMode: "eager", webpackExports: ["ClientFeaturedImage"] */ "/vercel/path0/components/client-featured-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommentSection"] */ "/vercel/path0/components/comment-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EditPostButton"] */ "/vercel/path0/components/edit-post-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadingReset"] */ "/vercel/path0/components/loading-reset.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
